import {Component, OnInit} from '@angular/core';
import {CompanySelectorService} from './shared/services/company-selector.service';
import {KeycloakService} from 'keycloak-angular';
import {CookieService} from 'ngx-cookie-service';
import {SwCacheService} from './utils/sw-cache.service';
import {Router, RouterOutlet} from '@angular/router';
import {CompanyService} from '@ems/api';
import {StaticSegmentsService} from './utils/static-segment.service';
import {AuthService} from './shared/services/auth.service';
import {environment} from '../environments/environment';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  shouldRedirectToHome = false;
  loading = true;

  constructor(
    private companyService: CompanyService,
    private companySelectorService: CompanySelectorService,
    private keycloak: KeycloakService,
    private cookieService: CookieService,
    private swCacheService: SwCacheService,
    private router: Router,
    private staticSegmentsService: StaticSegmentsService,
    private authService: AuthService
  ) {
  }

  async ngOnInit() {
    const keycloakAuth = this.keycloak.getKeycloakInstance();
    const lastSubject = this.cookieService.get('lastSubject');

    // reset SW cache in case of a new account logging in - do this on login, because logout is not reliable
    // currently this only works on page reload, because on explicit logout all cookieService.deleteAll is called and lastSubject is lost
    if (keycloakAuth.authenticated && keycloakAuth.subject && lastSubject !== keycloakAuth.subject) {
      // keycloak login can contain a redirect url; in case the user changes we want to start at home
      this.shouldRedirectToHome = true;
      this.cookieService.deleteAll();
      this.cookieService.set('lastSubject', keycloakAuth.subject);
      await this.swCacheService.clearCacheStorage();
    }

    if (['local', 'test'].includes(environment.envName)) {
      console.log(this.authService.getUserInfo());
    }

    // load companies first, then enable pages
    this.companyService.getAllCompanies('customer').subscribe((items: any[]) => {
      const filteredItems = items.filter((items: any) => items.parent_id === null);
      this.loading = false;

      this.companySelectorService.setCompanies(filteredItems.length > 0 ? filteredItems : items);
      if (this.shouldRedirectToHome) {
        this.router.navigate(this.staticSegmentsService.getPrefixToSegment('home'));
      }
    });

    document.title = this.getDynamicTitle();
  }

  private getDynamicTitle(): string {
    const suffix = '| smart media world';
    if (this.authService.isSug()) {
      return `S&G ${suffix}`;
    }
    if (this.authService.isEms()) {
      return `ems ${suffix}`;
    }
    return 'smart media world';
  }
}
